import React from 'react';

interface FilterDropdownProps {
  businessUnitOptions: { id: string; name: string,isFilter:boolean }[];
  formData: {
    businessUnit: string;
  };
  handleChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  borderType: number;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  businessUnitOptions,
  formData,
  handleChange,
  borderType=1,
}) => {
  const type = {
    1: "border-[3px] border-t-0 lg:border-x-0 lg:border-[3px]",
    2: "border-[3px] border-t-0 sm:border-t-[3px] sm:border-l-0",
  }[borderType];

  return (
      <select
        name="businessUnit"
        title="businessUnit"
        className={`flex-grow p-2 bg-transparent font-medium ${type} border-primary focus:outline-none text-gray-800`}
        value={formData.businessUnit}
        onChange={handleChange}
      >
        <option value="">All Business Unit</option>
        {businessUnitOptions.filter(unit => unit.isFilter
        ).map((unit) => (
          <option key={unit.id} value={unit.name}>
            {unit.name}
          </option>
        ))}
      </select>
  );
};

export default FilterDropdown;
